// 日期换,xx月xx日
function fdate(va) {
    let date = new Date(va);
    return date.getMonth() + 1 + "月" + date.getDate() + "日"
}
// 截取日期
function fdate2(va) {
    if (!va) return ""
    return va.slice(0, 10)
}
//*姓名脱敏
function tmName(val) {
    if (!val) return;
    val = val.replace(/^\s+|\s+$/g, "");
    if (val && val.length == 2) {
        return val.replace(/^(.{1}).*(.{1})$/, "$1*");
    } else if (val && val.length > 2) {
        return val.replace(/^(.{1}).*(.{1})$/, "$1***$2");
    } else {
        return val;
    }
}

// 语言
function langf(va) {
    switch (va) {
        case "zh-CN":
            return "中文";
        case "en":
            return "English";
    }
}
export default {
    tmName, fdate, fdate2, langf
};